import {CheckCircle} from '@phosphor-icons/react';
import ExpandableCards from '../../Components/ExpandableCards/ExpandableCards';
import './Services.less';
import {advantages, advantagestow} from './ServicesData';
import {Input} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import img from '../../assets/slider-image.jpg';
import MainFormWithSlider from '../../Components/MainFormWithSlider/MainFormWithSlider';
import {cardsData} from '../FAQ/homeData';
import ServicesSection from '../../Components/ServicesSection/ServicesSection';
import {sliderItems} from '../Home/Home';

const Services = () => {
	const formFields = [
		{
			name: 'fullName',
			rules: [{required: true, message: 'Please enter your Full Name!'}],
			input: <Input placeholder="Full name" className="default-input" />
		},
		{
			name: 'email',
			rules: [{required: true, message: 'Please enter your email!'}],
			input: <Input placeholder="Email address" className="default-input" />
		},
		{
			name: 'subject',
			rules: [{required: true, message: 'Please enter your subject!'}],
			input: <Input placeholder="Subject" className="default-input" />
		},
		{
			name: 'phone',
			rules: [
				{required: true, message: 'Please enter your phone!'},
				{
					pattern: /^\+?\d+$/,
					message: 'Please enter a valid phone number!'
				}
			],
			input: <Input placeholder="Phone Number" className="default-input" />
		},
		{
			name: 'brand',
			rules: [{required: true, message: 'Please enter your Company Name!'}],
			input: <Input placeholder="Company Name" className="default-input" />
		},
		{
			name: 'message',
			rules: [{required: true, message: 'Please enter your message!'}],
			input: <TextArea rows={4} style={{resize: 'none'}} placeholder="Your message" />
		}
	];
	return (
		<div className="services">
			<ServicesSection />
			<section className="services-advantages-from">
				<div className="services-advantages-from__container">
					<div className="services-advantages-from-title">
						<div className="services-advantages-from-title__container">
							<h1 className="services-swft-sistem-title">
								Your advantages from ITG-S.W.I.F.T. Service Bureau
							</h1>
							<p className="services-swft-sistem-description">
								Our comprehensive services include SWIFT support, configuration modifications,
								and consulting to ensure your operations run smoothly.
							</p>
						</div>

						<div className="services-your-advantages__container">
							{advantages.map((el: any, index: any) => {
								return (
									<div className="services-your-advantages" key={index}>
										<CheckCircle size={22} color="#1C70CA" />
										<div className="advantage__description"> {el.description}</div>
									</div>
								);
							})}
						</div>
					</div>
					<div className="services-advantages-from-text-box">
						{advantagestow.map((el: any, index: any) => {
							return (
								<div className="services-your-advantages" key={index}>
									<CheckCircle size={22} color="#1C70CA" />
									<div className="advantage__description"> {el.description}</div>
								</div>
							);
						})}
					</div>
				</div>
			</section>
			<footer className="services-contacts-box">
				<MainFormWithSlider formFields={formFields} carouselItems={sliderItems} />
			</footer>
		</div>
	);
};
export default Services;
